// ./src/components/features/Inventory/inventoryExpiry.ts
//
// A lot's EXPIRY — a calendar date, stored as that day's midnight UTC (the server's `normExpiry`). Read as the UTC day,
// never moved into this device's zone (ROADMAP #93). A leaf (dayjs only) so `check-event-zone` can run it.
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

// A lot within `EXPIRING_SOON_DAYS` of now is flagged; mirror the backend window.
export const EXPIRING_SOON_DAYS = 30;

export type ExpiryState = "none" | "ok" | "soon" | "expired";

/**
 * A lot's expiry is a CALENDAR DATE, stored as that day's midnight UTC (the server's `normExpiry`) — so it is read as
 * the UTC day, never moved into this device's zone (ROADMAP #93: west of UTC, "Oct 4" showed as "Oct 3" and a lot
 * read as expired a day early). Null when there is none or it cannot be read.
 */
const expiryDay = (expiresAt?: string | null): string | null => {
  if (!expiresAt) {
    return null;
  }

  const d = dayjs.utc(expiresAt);

  return d.isValid() ? d.format("YYYY-MM-DD") : null;
};

/** How close a lot's expiry is — drives the badge on the balances list. Compared with TODAY on this device. */
export const expiryState = (expiresAt?: string | null): ExpiryState => {
  const day = expiryDay(expiresAt);

  if (!day) {
    return "none";
  }

  const today = dayjs().format("YYYY-MM-DD");

  if (day < today) {
    return "expired";
  }

  if (dayjs.utc(day).diff(dayjs.utc(today), "day") <= EXPIRING_SOON_DAYS) {
    return "soon";
  }

  return "ok";
};

/** A short human date for a lot's expiry (the day that was picked), or "" when none. */
export const formatExpiry = (expiresAt?: string | null): string => {
  const day = expiryDay(expiresAt);

  return day ? dayjs.utc(day).format("MMM D, YYYY") : "";
};
